// extracted by css-extract-rspack-plugin
export default {"icon":"ProviderTypeIcon-module__icon___CR160","mark":"ProviderTypeIcon-module__mark___Hg7f3"};